import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import "./PageMgr.scss";
// import { METHOD, CONTENT_TYPE } from "src/lib/http/HttpEmun";
import IUIItem from "src/engine/interface/IUIItem";
import Config from "src/engine/const/Config";
import UIManifest from "src/engine/ui/UIManifest";
import { IPanelContext } from "src/engine/context/PanelContext";
import IGameInfo from "src/engine/interface/IGameInfo";
import { IJJHistory } from "../source/JJHistory";
import PageLoading from "./PageLoading";
import Resolution from "./Resolution";
import SourceEngine from "src/engine/source/SourceEngine";
import SourceCenter from "src/engine/SourceCenter";
import PageMgrContext from "./PageMgrContext";
import { Types } from "../source/AppRoot";
import Manifest from "src/engine/Manifest";
import JsonCenter from "src/component/props/PropsExpend/JsonCenter";
import Style from "src/lib/utils/Style";

interface IPCPageMgr extends IBaseUI {
    pages: IUIItem[];

    /**
     * 自定义页面
     *
     * @type {IUIItem[]}
     * @memberof IBaseUI
     */
    pageTemps: { [key: string]: IUIItem };

    history: IJJHistory[];

    jjHistory: any;

    init: false;

    isPC: boolean | "true" | "false";

    offset: number;

    isResolution: boolean;

    gameInfo: IGameInfo;

    sources: IUIItem[];

    singleExit: boolean;

    bridgeUI: IUIItem[];
    loadingUI: IUIItem[];
    loadErrorUI?: IUIItem[];
    maxFontSize?: number | undefined; //最大的fontsize
    noJsonToast?: boolean;
    config?: any;
}
interface IState {
    pageError: boolean;
    mobileStyle?: any;
}
@UIManifest.declare("PCPageMgr", "页面管理器", UIManifest.Type.PageMgr)
class PageMgr extends BaseUI<IPCPageMgr, IState> {
    componentDidMount() {
        const { source, singleExit, jjHistory, init } = this.props;
        if (!source || source === "") return;
        if (!init) this.initJson(source);
        this.setExit(singleExit);
        jjHistory.registerHashChange((type: string | Types, props?: any) => {
            this.sourceContext.execSource("manager", { type, ...props });
        });
    }
    state = {
        pageError: false,
        mobileStyle: {},
    };
    initJson(source: string) {
        const win: any = window;
        const { config } = this.props;
        this.getJson("pages", config?.updateEveryTime ? undefined : win.TEMP_UPDATE_TIME);
    }
    setExit = (type: boolean) => {
        const fun = this.props.jjHistory.setSingleExit;
        if (fun) {
            fun(type);
        }
    };
    UNSAFE_componentWillReceiveProps(next: any) {
        if (next.singleExit !== this.props.singleExit) {
            this.setExit(next.singleExit);
        }
    }

    public shouldComponentUpdate(nextProps: any = {}, nextState = {}) {
        return true;
    }

    /**
     * 获取页面数据
     *
     * @memberof PageMgr
     */
    getJson = (path: string, updateTime: number = new Date().valueOf(), refresh: boolean = true) => {
        const { gameInfo } = this.props;
        const url = Config.getConfig(gameInfo.server, gameInfo.gameId, path);
        JsonCenter.Instance.ajax(
            url,
            (data: any, CODE: number) => {
                if (CODE != 200) {
                    this.setState({ pageError: true });
                    return;
                } else {
                    this.sourceContext.execSource("manager", data, undefined, undefined, undefined, undefined, undefined, refresh);
                }
            },
            false,
            updateTime,
            1000 * 60 * 60,
        );
    };

    componentWillUnmount() {
        this.sourceContext.execSource(this.props.source || "manager", { type: "uninit" });
        super.componentWillUnmount();
    }

    pageChange = (active: any) => {
        const { source } = this.props;
        if (!source || source === "") return;

        this.sourceContext.execSource(source, { type: "pageChange", active });
    };

    renderSinglePage = ({ props, ename, key }: IJJHistory, index: number = 0, show: boolean = false) => {
        const { pageTemps = {}, pageUpdateTime = {}, history = [], jjHistory, isPC, loadErrorUI } = this.props as any;
        const page = pageTemps[ename];
        if (!page) {
            return (
                <PageLoading
                    uiItem={{
                        info: { ename, cname: "" },
                        ui: "",
                        props: { updateTime: pageUpdateTime[ename] || "1" },
                    }}
                    loadErrorUI={loadErrorUI}
                    pageError={this.state.pageError}
                    isPC={isPC}
                    key={`${key}_${ename}`}
                    getJson={this.getJson}
                />
            );
        }
        let hidden = false;
        if (!show) {
            hidden = index < history.length - 2;
            const next = history[index + 1];
            if (next) {
                if (pageTemps[next.ename]) hidden = true;
            }
        }
        //渲染页面
        return this.mPanelContext.renderUIItem(page, {
            intent: props,
            key: `${ename}_${key || 0}_${index}`,
            hidden,
            last: index === history.length - 1,
            index,
            isPC,
            jjHistory,
            mobileStyle: this.state.mobileStyle,
            registerModal: this.registerModal,
        });
    };

    renderPage(noMenu: boolean = false) {
        const { history = [], pagesStyle } = this.props as any;

        const ret = history.map((item: IJJHistory, index: number) => {
            return this.renderSinglePage(item, index);
        });

        if (!noMenu && pagesStyle) {
            const { pagesStyle } = Style.getMainStyle(["pagesStyle"], this.props);
            return <div style={pagesStyle}>{ret}</div>;
        }
        return ret;
    }
    modalBack: any;
    registerModal = (fun: any) => {
        this.modalBack = fun;
    };
    getModal = () => {
        return this.modalBack;
    };
    renderContent = (context: IPanelContext) => {
        const { init = false, uiItem, isPC = false, loadingUI, bridgeUI, pageTemps = {}, jjHistory, loadErrorUI, config = {}, pages } = this.props;
        this.mPanelContext = context;
        const defaultMenu = jjHistory.history[jjHistory.history.length - 1]?.ename;
        const page = pageTemps[defaultMenu];

        const noMenu = page?.props.menu?.single === "true";
        return (
            <PageMgrContext.context.Provider value={{ loading: loadingUI, renderPage: this.renderSinglePage as any }}>
                <div
                    className={`react-pc-pagemgr ${isPC === "true" || isPC === true ? "pc" : ""} ${config.isHscreen ? "is-hscreen" : ""}`}
                    style={this.getStyle()}
                >
                    {noMenu ? null : this.renderChildren(bridgeUI, { jjHistory, defaultMenu, getModal: this.getModal, pages })}
                    {!init ? <PageLoading uiItem={uiItem} isPC={isPC} loadErrorUI={loadErrorUI} /> : this.renderPage(noMenu)}
                </div>
            </PageMgrContext.context.Provider>
        );
    };

    // renderSource = (context: IPanelContext) => {
    //     const { sources = [], stores = [] } = this.props as any;
    //     if (sources.length === 0) return this.renderContent(context);

    //     return (
    //         <SourceCenter ename="PageMgr" uiItem={Manifest.ui()} stores={stores} sources={SourceEngine.create(sources)} updateTheme={context.updateTheme}>
    //             {this.renderContent(context)}
    //         </SourceCenter>
    //     );
    // };

    renderCenter(callback: (context: IPanelContext) => any) {
        const { sources = [], updateTheme, stores = [] } = this.props as any;
        if (sources.length === 0 && stores.length === 0) return this.panel(callback);
        return (
            <SourceCenter ename="PageMgr" uiItem={Manifest.ui()} stores={stores} sources={SourceEngine.create(sources)} updateTheme={updateTheme}>
                {this.panel(callback)}
            </SourceCenter>
        );
    }

    mPanelContext: IPanelContext;

    renderAct() {
        const { isResolution = true, config = {} } = this.props as any;
        if (!isResolution) return this.renderCenter(this.renderContent);
        // let width = 720;
        // if (config.isHscreen) {
        //     // 是否是横屏项目
        //     if (window.screen.width > window.screen.height) {
        //         // 横屏 加当前屏幕横竖判断的原因： 一个横屏项目中需要竖屏的页面
        //         width = 1280;
        //     }
        // }
        return (
            <Resolution
                offset={this.props.offset}
                width={720}
                hWidth={1280}
                isHscreen={config.isHscreen}
                resizeScreen={true}
                maxFontSize={this.props.maxFontSize}
                maxWidth={config.useMaxWidth}
                isResolution={config.noResolution}
                mobStore={config.outToStore}
            >
                {this.renderCenter(this.renderContent)}
            </Resolution>
        );
    }
}

export default PageMgr;
